<ul [ngClass]="cn('flex items-center gap-[22px]', uiClass())">
  @for (link of navLinks(); track $index) {
    @if (link.label !== 'My Account' || isLoggedIn()) {

      <!-- 👇 Regular Nav Links -->
      @if (link.label !== 'Booking') {
        <li>
          <a
            [ngText]="linkTextKey()"
            [routerLink]="link.path"
            [ngClass]="cn('font-semibold transition-all duration-300 group !text-white hover:opacity-70', linkClass())"
          >
            {{ link.label }}
          </a>
        </li>
      }

      <!-- 👇 Booking Dropdown -->
      @else {
        <li nz-dropdown nzTrigger="hover" [nzDropdownMenu]="bookingMenu">
          <a
            nz-dropdown
            [ngText]="linkTextKey()"
            [ngClass]="cn('font-semibold transition-all duration-300 group !text-white hover:opacity-70 flex items-center gap-2', linkClass())"
          >
            Booking
            <i nz-icon nzType="down" class="text-xs"></i>
          </a>
        </li>

        <nz-dropdown-menu #bookingMenu="nzDropdownMenu">
          <ul nz-menu class="!min-w-[160px]">
            @for (option of link.children; track $index) {
              <li nz-menu-item>
                <a
                  [routerLink]="option.path"
                  class="text-gray-700 hover:text-primary-600 transition"
                >
                  {{ option.label }}
                </a>
              </li>
            }
          </ul>
        </nz-dropdown-menu>
      }
    }
  }
</ul>
